import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { SessionManager } from '../../session/service/session-manager';
import { CampaignId } from '../../module/campaign-util/shared/campaign-id';
import { HttpClient } from '@angular/common/http';
import { SessionTokenService } from '../../session/service/session-token';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GlobalEventBus } from '../../shared/event/global-bus';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as moment from 'moment-timezone';
import { TimezoneModalComponent } from './timezone-modal.component';
import { TimezoneStorage } from '../../shared/misc/service/timezone-storage';
import { DeviceSizeService } from '../../shared/services/device-size.service';
import { DeviceSizes } from '../../shared/enum/device-size';

@Component({
  selector: 'topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})

export class TopbarComponent implements OnInit, OnDestroy {

  routeChangeSubscription: Subscription;

  campaign: any = null;
  campaigns: any = [];
  user: any = {};
  hasAdminSession: boolean = false;
  timer: any;
  notifications: any[] = [];
  isOpen: boolean = false;
  isSidebarOpen: boolean = false;
  modalRef: BsModalRef;
  isSmallDevice = false;

  @Output()
  sidebarChanged = new EventEmitter<boolean>();

  constructor(private sessionManager: SessionManager,
              private sessionToken: SessionTokenService,
              private httpClient: HttpClient,
              private route: ActivatedRoute,
              private toastrService: ToastrService,
              private router: Router,
              private globalEventBus: GlobalEventBus,
              private modalService: BsModalService,
              private campaignId: CampaignId,
              private deviceSize: DeviceSizeService) {
  }

  onClickMenu(event: Event) {
    event.preventDefault();
    this.isSidebarOpen = !this.isSidebarOpen;
    this.sidebarChanged.emit(this.isSidebarOpen);
  }

  onClick(event: Event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
  }

  ngOnInit() {
    this.checkNotifications();
    // this.timer = setInterval(() => {
    //   this.checkNotifications();
    // }, 30 * 1000);

    this.hasAdminSession = !!this.sessionToken.getAdminToken().token;

    this.globalEventBus.bind('campaign:created', () => {
      this.load();
    });

    this.globalEventBus.bind('user:updated', () => {
      this.loadUser();
    });

    this.user.timezone = moment.tz.guess();
    this.load();
    this.loadUser();

    this.campaignId.channel.subscribe((id: string) => {
      const campaign = this.campaigns.find(c => c.uuid === id);
      if (campaign) {
        this.campaign = campaign;
      } else {
        this.campaign = null;
      }
    });
    this.listenForDeviceSizeChange();
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  loadUser() {
    this.sessionManager.getIdentity()
      .subscribe((user: any) => {
        this.user = user;
      });
  }

  load(): Subscription {
    return this.httpClient.get('/cms/campaign', {
      params: {
        limit: '999',
      },
    })
      .subscribe((response: any) => {
        this.campaigns = response.filter(c => {
          return c.status === 'live';
        });
        if (this.campaignId.getId()) {
          const campaign = this.campaigns.find(c => c.uuid === this.campaignId.getId());
          if (campaign) {
            this.campaign = campaign;
          }
        }
      });
  }

  logout() {
    this.campaignId.release();
    this.sessionManager.destroy();
  }

  backToAdmin() {
    this.campaignId.release();
    this.sessionToken.persist(this.sessionToken.getAdminToken());
    TimezoneStorage.store(localStorage.getItem('adminTimezone'));
    this.sessionToken.destroyAdminToken();
    this.router.navigate(['/admin/accounts']);
  }

  checkNotifications() {
    this.httpClient.get('/notification')
      .subscribe(
        (response: any) => {
          this.notifications = response;
        }, (error: any) => {
          console.log(error);
        },
      );
  }

  readNotification(notification) {
    this.httpClient.put(`/notification/${ notification.id }`, {})
      .subscribe(
        (response: any) => {
          notification.readDate = response.readDate;
        },
      );
  }

  createInvoices() {
    this.httpClient.post('/admin/payment/create-invoices', {})
      .subscribe(() => {
        this.toastrService.success('Invoices should be available in a few moments');
      }, () => {
        this.toastrService.error('Could not create invoices');
      });
  }

  changeTimezone() {
    this.modalRef = this.modalService.show(TimezoneModalComponent, {
      backdrop: 'static',
      keyboard: false,
      class: 'modal-sm',
      animated: false,
      ignoreBackdropClick: false,
    });
  }

  listenForDeviceSizeChange(): void {
    // Method takes DeviceSize from service and compare with enums which we are interested in,
    // then set variable to specific boolean value - use in GoPhoto logo displaying
    this.deviceSize.deviceSize$.subscribe((deviceSize) => {
      if ((deviceSize === DeviceSizes.mobile) ||
        (deviceSize === DeviceSizes.largeMobile) ||
        (deviceSize === DeviceSizes.tablet)
      ) {
        this.isSmallDevice = true;
      } else {
        this.isSmallDevice = false;
      }
    });
  }
}
